import { faCalendar } from "@fortawesome/pro-regular-svg-icons";
import { Badge } from "components/badge/Badge";
import Card from "components/card/Card";
import DataTable from "components/dataTable/DataTable";
import Sheet from "components/sheet/Sheet";
import Spin from "components/spin/spin";
import useModal from "hooks/modals/useModal";
import { useAppDispatch } from "hooks/redux";
import moment from "moment";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { selectDate } from "redux/actions/teesheet";
import EmptyStatus from "../../emptyStatus/EmptyStatus";
import "./events.scss";

interface IEvent {
  event_id: number;
  event_name: string;
  event_type: "league" | "tournament" | "shotgun";
  start_time: string;
  end_time: string;
}

interface IProps {
  events: Array<IEvent>;
  date: Date;
}

export default function Events(props: IProps) {
  const { events, date } = props;
  const { state: viewAllModal, updateModal: updateViewAllModal, closeModal: closeViewAllModal } = useModal();
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useAppDispatch();
  return (
    <>
      <Card
        title={t("Events")}
        titleActions={[
          {
            content: t("View All"),
            action: () => updateViewAllModal({ isOpen: true }),
            disabled: !events || events?.length === 0,
          },
        ]}
      >
        <Card.Section>
          {events === undefined ? (
            <div style={{ height: "40px", display: "flex", width: "40px", margin: "auto" }}>
              <Spin />
            </div>
          ) : events?.length === 0 ? (
            <EmptyStatus
              title={t("No Events Today")}
              description={t("Currently, no tee sheet events are scheduled for today.")}
              action={{
                label: t("Edit tee sheet"),
                onClick: () => {
                  dispatch(selectDate(date));
                  history.push("/admin/teesheet/edit");
                },
              }}
              icon={faCalendar}
            />
          ) : (
            <div className="ui-events-container">
              {events
                ?.filter((_, inx) => inx < 4)
                ?.map((teeTimeEvent, index) => {
                  return (
                    <div key={index} className="ui-events-card">
                      <div className="ui-events-times">
                        <Badge type="lightblue" size="small">
                          {moment(teeTimeEvent?.start_time, "HH:mm")?.format("LT")} -{" "}
                          {moment(teeTimeEvent?.end_time, "HH:mm")?.format("LT")}
                        </Badge>
                      </div>
                      <p>{teeTimeEvent?.event_name}</p>
                    </div>
                  );
                })}
            </div>
          )}
        </Card.Section>
      </Card>
      <Sheet
        open={viewAllModal.isOpen}
        title={t("View All Events")}
        size="medium"
        onCancel={closeViewAllModal}
        backDropCancel
      >
        <DataTable columns={[{ label: t("Title") }, { label: t("Time") }]}>
          {events?.map((teeTimeEvent, index) => {
            return (
              <tr key={index}>
                <td>{teeTimeEvent?.event_name}</td>
                <td>
                  <Badge type="lightblue" size="small">
                    {moment(teeTimeEvent?.start_time, "HH:mm")?.format("LT")} -{" "}
                    {moment(teeTimeEvent?.end_time, "HH:mm")?.format("LT")}
                  </Badge>
                </td>
              </tr>
            );
          })}
        </DataTable>
      </Sheet>
    </>
  );
}
